/* import pricesApi from "../../api/prices" */
import utilsApi from "../../api/utils"

// general state for the eCommerce
const state = {
  prices: [],
  fetched: false,
  error: false,
  dataShape: [],
  extraInfo: {},
}

const getters = {
  prices: state => state.prices,
  prices_fetched: state => state.fetched,
  pricesError: state => state.error,
  prices_dataShape: state => state.dataShape,
  prices_extraInfo: state => state.extraInfo,
}
const actions = {
  async DELETE_prices({ commit }, price) {
    let apiResponse = await utilsApi.deleteObject("prices", price)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PRICES_SETTING", apiResponse)
    } else {
      commit("PRICES_ERROR")
    }
  },
  async CREATE_prices({ commit }, price) {
    let apiResponse = await utilsApi.createObject("prices", price)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PRICES_SETTING", apiResponse)
    } else {
      commit("PRICES_ERROR")
    }
  },
  async SAVE_prices({ commit }, price) {
    let apiResponse = await utilsApi.saveObject("prices", price)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PRICES_SETTING", apiResponse)
      return true
    } else {
      commit("PRICES_ERROR")
      return false
    }
  },
  async FETCH_prices({ commit }) {
    let apiResponse = await utilsApi.getObjects("prices")
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PRICES_SETTING", apiResponse)
      return true
    } else {
      commit("PRICES_ERROR")
      return false
    }
  },
}
const mutations = {
  PRICES_SETTING: (state, { prices, dataShape, extraInfo }) => {
    console.log(state)
    state.prices = prices
    state.dataShape = dataShape
    state.extraInfo = extraInfo
    state.fetched = true
    state.error = false
  },
  PRICES_ERROR: state => {
    state.prices = null
    state.fetched = true
    state.error = false
    state.dataShape = []
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
